import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'react-bootstrap';

// EU-14 allergen code -> English default label (translated via the message catalog when available).
const ALLERGEN_LABELS = {
    gluten: 'Gluten',
    crustaceans: 'Crustaceans',
    eggs: 'Eggs',
    fish: 'Fish',
    peanuts: 'Peanuts',
    soy: 'Soy',
    milk: 'Milk',
    nuts: 'Nuts',
    celery: 'Celery',
    mustard: 'Mustard',
    sesame: 'Sesame',
    sulphites: 'Sulphites',
    lupin: 'Lupin',
    molluscs: 'Molluscs',
};

const capitalize = value => `${value.charAt(0).toUpperCase()}${value.slice(1)}`;

// True when the structured allergens object holds at least one code.
export function hasAllergens(allergens) {
    return !!allergens && (((allergens.contains || []).length + (allergens.mayContain || []).length) > 0);
}

function renderBadge(code, props) {
    return (
        <Badge key={code} {...props}>
            <FormattedMessage id={`productAllergen${capitalize(code)}`} defaultMessage={ALLERGEN_LABELS[code] || code} />
        </Badge>
    );
}

function ProductAllergens({ product }) {
    const allergens = (product.foodData || {}).allergens || {};
    const contains = allergens.contains || [];
    const mayContain = allergens.mayContain || [];

    if(!hasAllergens(allergens)) {
        return null;
    }

    return (
        <Fragment>
            {contains.length > 0 && (
                <div className="mb-2">
                    <span className="me-2"><FormattedMessage id="productAllergensContains" defaultMessage="Contains" /> :</span>
                    {contains.map(code => renderBadge(code, { bg: 'secondary', className: 'me-1 mb-1 fw-normal' }))}
                </div>
            )}
            {mayContain.length > 0 && (
                <div className="mb-2">
                    <span className="me-2 text-black-50"><FormattedMessage id="productAllergensMayContain" defaultMessage="May contain traces of" /> :</span>
                    {mayContain.map(code => renderBadge(code, { bg: 'light', text: 'dark', className: 'me-1 mb-1 fw-normal border' }))}
                </div>
            )}
        </Fragment>
    );
}

ProductAllergens.propTypes = {
    product: PropTypes.object.isRequired,
};

export default ProductAllergens;
